export default {
  remind: (client, params) => client.$post('document_bundle/remind', params),
  createAll: (client, params) => client.$post('document_bundle/all', params),
  createSingle: (client, product_id, t) => client.$post(`document_bundle/single/${product_id}`, { t })
}